'use strict';
const euCountries = [
    'AT', 'BE', 'BG', 'HR',
    'CY', 'CZ', 'DK', 'EE',
    'FI', 'FR', 'DE', 'GR',
    'HU', 'IE', 'IT', 'LV',
    'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK',
    'SI', 'ES', 'SE', 'GB',
    'UK'
];

const EAuthResult = {
    VALID: 1,
    NOT_EXISTED: -1,
    OTHER_ERRORS: -3
}

// 订阅状态
const subscribeStatus = {
    succeeded: 'succeeded',
    validError: 'validError',
    repeatError: 'repeatError',
    frequentError: 'frequentError',
    serverError: 'serverError'
}


const EEmailState = {
    VALIDATED_EMAIL: 1, // 验证通过
    VALID_ERROR: 0, // Valid_error
}

// 必填、长度：255，格式、真实性

const $checkedInput = $('.footer-subscribe-checkbox .checkbox-span input');
const $subscribeInput = $('.footer-flex-content input');
const subject = $('.reo-subscription-box').attr('data-notify');
const checkboxLabelValueA = $('.footer-subscribe-checkbox .checkbox-label .checkbox-label-value a');
const checkboxLabel = $('.footer-subscribe-checkbox .checkbox-label');

// 初始化订阅框
function initSubscribe() {
    $('tips-wrap').addClass('hide');
    $('.tips-wrap .error-attention').addClass('hide');
    $('.success-tips').addClass('hide');
    $('.footer-flex-content').removeClass('hide');
}

define('subscribe', [], function () {
    const reoSubscribe = (email, subject) => {

        const data = JSON.stringify({
            email: email,
            subject: subject
        });
        return new Promise((resolve, reject) => {
            $.post({
                // 配置完整路径
                url: `https://${config.domains.official}${config.reolinkDomains.reoUrl}/subscriptions/`,
                data,
                headers: {'content-type': 'application/json'},
                success: res => {
                    if(res && res.result && res.result.code === 0) {
                        resolve(res)
                    }
                    else {
                        reject(res);
                    }
                },
                error: rej => reject(rej)
            });
        })
    };

    /**
     * FormValidator
     *
     * @interface IField
    */

    class FormValidator {
        constructor () {
            this._regexs = {
                username: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{3,16}$/,
                method: /^(.+)\((.+)\)$/,
                start2End: /^(.+)\[(\d?,\d?)\]$/,
                email: /^[-+_a-z0-9][-+_.a-z0-9]{0,62}@[a-z0-9][-a-z0-9]{0,62}(\.[a-z0-9][-a-z0-9]{0,62})*\.[a-z]{2,26}$/i,
                phone: /^[\s#0-9_\-+()]+$/,
                password: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{6,30}$/,
                numeric: /^[+-]?([0-9]*[.])?[0-9]+$/,
                numericNoSymbols: /^[0-9]+$/,
                int: /^[-+]?(0|[1-9]\d*)$/,
                uint: /^(0|[1-9]\d*)$/,
                float: /^([+-]?((0|[1-9]\d*)\.[0-9]*))|([+-]?(0|[1-9]\d*))$/,
                alpha: /^[a-zA-Z]+$/,
                alphaNumeric: /^[a-zA-Z0-9]+$/,
                alphaDash: /^[a-zA-Z0-9_-]+$/
            };

            this._testHooks = {

                required: (field) => {

                    const { fieldValue, type, checked } = field || {};
                    if (type === 'checkbox' || type === 'radio') {

                        return checked === true;
                    }
                    return fieldValue !== null && fieldValue !== '';
                },
                isEmail: (field) => {

                    return this._regexs.email.test(field.fieldValue);
                },
                minLength: (field, length) => {

                    if (!this._regexs.numeric.test(length)) {

                        return false;
                    }
                    return field.fieldValue.length >= parseInt(length, 10);
                },
                maxLength: (field, length) => {

                    if (!this._regexs.numeric.test(length)) {

                        return false;
                    }
                    return field.fieldValue.length <= parseInt(length, 10);
                },
                exactLength: (field, length) => {

                    if (!this._regexs.numeric.test(length)) {

                        return false;
                    }
                    return field.fieldValue.length === parseInt(length, 10);
                }
            };
        }

        check(rule, stringToValidate) {

            const funParts = this._regexs.method.exec(rule);
            if (funParts) {

                const fun = this._testHooks[funParts[1]];
                const field = { fieldValue: stringToValidate };
                return fun(field, funParts[2]);
            }
            else {

                const fun = this._testHooks[rule];
                const field = { fieldValue: stringToValidate };
                return fun(field);
            }
        }

    }

    const V = new FormValidator();


    /**
     * 功能模块
     * 邮箱真实性验证器
     */

    /* 邮箱验证接口 */
    function validateEmailApi(email) {
        const data = JSON.stringify({
            email: email
        });

        return new Promise((resolve, reject) => {
            $.post({
                url: `${config.reolinkDomains.api}${config.reolinkDomains.serviceUrl}/email/validation`,
                data,
                options: { type: 'service'},
                headers: {'content-type': 'application/json'},
                success: res => resolve(res),
                error: rej => reject(rej)
            });
        })
    }


    const emailAuthenticator = {

        /**
         * @param   {String} email 待校验真实性的邮箱
         * @returns {Promise<EAuthResult>} 邮箱真实性验证结果
         */
        async getEmailAuthenticity(email) {

            try {

                const result = await validateEmailApi(email);
                if(result.result === 'valid') {
                    return EAuthResult.VALID;
                }
                else{
                    return EAuthResult.NOT_EXISTED;
                }
            }
            catch (err) {
                console.error(err);
                return EAuthResult.OTHER_ERRORS;
            }

        }
    };

    class SubscribeFeatures {
         async _validateEmail(email) {
            if(!email.trim().length) {
                return EEmailState.VALID_ERROR; // 邮箱为空，状态码为0
            }
            // 验证格式
            if(!V.check('isEmail', email)) {
                return EEmailState.VALID_ERROR; // 邮箱格式错误，状态码为 -4
            }
            // 邮箱真实性校验
            const result = await emailAuthenticator.getEmailAuthenticity(email);
            if(result !== -1) {
                return EEmailState.VALIDATED_EMAIL;
            }
            else {
                return EEmailState.VALID_ERROR;
            }
        }

        async subscribeSubject(
            value,
            subject
        ) {
            try {
                const emailValidateState = await this._validateEmail(value);

                // 1: 通过
                if (emailValidateState) {
                    await reoSubscribe(value.trim(), subject);
                    return subscribeStatus.succeeded;
                }
                else {
                    // 0:valid_error
                    return subscribeStatus.validError;
                }

            }
            catch (e) {
                if(e && e.result && e.result.code === -7) {
                    return subscribeStatus.repeatError;
                }
                else if(e && e.result && e.result.code === -5) {
                    return subscribeStatus.frequentError;
                }
                else {
                    return subscribeStatus.serverError;
                }
            }
        };

    }

    const subscribeFeatures = new SubscribeFeatures();

    function handleFooterSubscribeClick(e) {
        e.preventDefault();
        $('.reo-subscription-box .submit-icon').toggleClass('disabled');
        // toggle input:checked
        $checkedInput.prop('checked', !$checkedInput.prop('checked'));

    }

    function handleHrefClick (e) {
        e.stopPropagation();
    }

    async function handleSubscribe(e) {
        // 点击设置按钮为loading状态
        const inputValue = $subscribeInput[0].value;
        $('.loading-status').removeClass('hide');
        $('.subscribe-btn').addClass('hide');
        try {
            const res = await subscribeFeatures.subscribeSubject(inputValue, subject);
            // init
            initSubscribe();

            if(res === subscribeStatus.succeeded) {
                $('.success-tips').removeClass('hide');
                $('.footer-flex-content').addClass('hide');
            }
            else {
                $('.tips-wrap').removeClass('hide');
                switch(res) {
                    case subscribeStatus.validError: $('.valid-tips').removeClass('hide'); break;
                    case subscribeStatus.serverError: $('.server-tips').removeClass('hide'); break;
                    case subscribeStatus.repeatError: $('.repeat-tips').removeClass('hide'); break;
                    case subscribeStatus.frequentError: $('.frequent-tips').removeClass('hide'); break;
                    default: ;
                }
            }
        } catch(e) {
            console.log(e);
        }
        finally {
            $('.loading-status').addClass('hide');
            $('.subscribe-btn').removeClass('hide');
        }
    }

    const subs = {};
    subs.init = function () {
        // 欧盟国家必须选中选框才能点击按钮
        if (euCountries.includes(app.user.location)) {
            $('.footer-subscribe-checkbox').removeClass('must-be-hidden');
            // button按钮的颜色是灰色，选择了tips后才变色，可点击
            $('.submit-icon').addClass('disabled');
        }

        // 解决链接父级被统一处理无法点击问题
        checkboxLabelValueA[0] && checkboxLabelValueA[0].addEventListener('click',(e) => handleHrefClick(e));

        // 统一处理checkbox and label
        checkboxLabel[0] && checkboxLabel[0].addEventListener('click',(e) => handleFooterSubscribeClick(e));

        // 订阅按钮
        $('.subscribe-btn').on('click', (e) => handleSubscribe(e));

        // focus: init subscribe
        $('.reo-subscription-box input').on('focus', () => {
            initSubscribe();
        })
    }

    return subs;
});
